import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AllocateMutationVariables = Types.Exact<{
  input: Types.AllocateCommandInput;
}>;


export type AllocateMutation = { __typename?: 'Mutation', allocateRestockSessionInventory: { __typename?: 'AllocationPayload', result?: { __typename?: 'AllocationResultData', feasibilityStatus: Types.FeasibilityStatus, warnings: Array<string>, allocations: Array<{ __typename?: 'StoreAllocationData', storeId: string, achievableQuantity: number, weeksOfSupply: number, demandMetPercentage: number, minConstraintApplies: boolean, minConstraintMet: boolean, shortfall: number }> } | null, errors?: Array<{ __typename?: 'AllocationErrorData', message: string, code: string }> | null } };


export const AllocateDocument = new TypedDocumentString(`
    mutation Allocate($input: AllocateCommandInput!) {
  allocateRestockSessionInventory(input: $input) {
    result {
      feasibilityStatus
      allocations {
        storeId
        achievableQuantity
        weeksOfSupply
        demandMetPercentage
        minConstraintApplies
        minConstraintMet
        shortfall
      }
      warnings
    }
    errors {
      message
      code
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    Allocate: build.mutation<AllocateMutation, AllocateMutationVariables>({
      query: (variables) => ({ document: AllocateDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAllocateMutation } = injectedRtkApi;
